import { createUseTranslation } from "core/session/translation";

export const useDefaultModalDialogTranslation = createUseTranslation({
  en: {
    translationSectionTitle: "Translation",
    configSectionTitle: "Configuration",
    isOpenButtonDisabled: "Open Button Disabled",
  },
});
